@if (!isLoading) {
  @for (note of footNotes; track note.id) {
    <div [id]="note?.id" class="c__footnote">
      <sd-html
        innerClass="c__content is-wysiwyg {{isSmall ? 'is-overline' : 'is-caption'}}"
        [html]="note?.note"
        tag="div"
      />

      @if (note?.refId) {
        <a [href]="'#' + note?.refId" class="is-visually-hidden-focusable">
          {{'actions.backToContent' | translate}}
        </a>
      }
    </div>
  }
}

@if (isLoading) {
  <sd-skeleton
    [appearance]="skeletonAppearanceEnum.line"
    [sizeChangeMobile]="false"
    [size]="sizesEnum.xxs"
    [count]="2"
  />
}
